import {
  Address,
  beginCell,
  StateInit,
  storeStateInit,
  toNano,
  Cell,
  contractAddress,
  fromNano,
} from "ton-core";
import { CHAIN, SendTransactionRequest } from "@tonconnect/ui-react";
import { saleConfigToCell } from "../../lib/wrappers/Sale";

const network =
  import.meta.env.VITE_PUBLIC_NETWORK === "mainnet"
    ? CHAIN.MAINNET
    : CHAIN.TESTNET;

const CONTRACT_CODE =
  "b5ee9c7241020e01000361000114ff00f4a413f4bcf2c80b0102016203020075a03859da89a1a803a1a601a63ff481f481f480600bf401a9a601a7fe6020f020ce20ac208ab7a1f481f401f481f4006104208c92b0a0158002ab010202cd070402d36a084017d784014a02814942fbcb87089b43e903e803e903e800c0af0803cb8e14ae9cc60192a4114842efcb8e18ae9cc60192a41148c2efcb8e214eca84868542a68462814ac1c20043232c15400f3c5807e80b2dab25c7ec009f08009f5d27080ac248d8db8c354152060500d6708010c8cb055003cf1601fa02cb6ac971fb00702082105fcc3d14c8cb1f13cb3f23cf165003cf16ca008209c9c380fa02ca00c9718018c8cb0528cf1670fa02cb6accc98306fb0071557008c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54002e5067708010c8cb055003cf1601fa02cb6ac971fb00104502f7d00e8698180b8d8492f82707d201876a2686a00e86980698ffd207d207d201802fd006a698069ff98083c0833882b0822b82985e38060004a9885e98f866f10e1804a1805e99fc708c5b31b0b731b2b6416e382c939996f280671166000c92f87f0166002f18111f971c3936ba4e10116c08115dd1660009159d8d840d0804f653dac705b09d1f5f0fd430d0d307d43001fb00e02bc001f2d194b38e4731353b3b5374c705925f0be05173c705f2e1f4821005138d9118baf2e1f5fa403010481037553208c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e02cc003e3022cc000e3022cc002e30231343b3b08c0060c0b0a0900768e325161c705f2e38a05fa00301048103746531408c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e05f0a840ff2f0002230393a106b105a1049103847060504f00600245b3839105a1049103847150450637002f00600e630393a3b821005f5e1001abef2e1c95361c7055174c70517b1f2e1ca702082105fcc3d14218010c8cb0526cf1621fa02cb6acb1f17cb3f22cf1622cf1616ca0025fa0215ca00c98306fb00710810374605431308c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54007a313239393939068308d71830ed44f9005116f910f2e38955334330710108c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54dd05067a";
const fixPriceV3R2Code = Cell.fromBoc(Buffer.from(CONTRACT_CODE, "hex"))[0];

export type SaleNftItemConfig = {
  nftAddress: string;
  saleAddress: string; //EQD9bB6ES0ZBSF_KdsHmgdtO3TqnCWQTOHpIom6I0GiGhbrq
  marketplaceFeeAddress: string;
  royaltyAddress: string;
  destinationAddress: string; //EQD9bB6ES0ZBSF_KdsHmgdtO3TqnCWQTOHpIom6I0GiGhbrq
  walletAddress: string;
  price: string;
  marketFee: string;
  royaltyFee: string;
  publicKey: string;
  signature: string;
  createdAt: number;
  queryId: number;
};

const getSendTransferBody = (
  ownerAddress: Address,
  value: bigint,
  recipient: Address,
  forwardPayload?: Cell,
  queryId?: bigint
) => {
  return beginCell()
    .storeUint(0x5fcc3d14, 32)
    .storeUint(queryId ? queryId : 0, 64)
    .storeAddress(recipient)
    .storeAddress(ownerAddress)
    .storeUint(0, 1)
    .storeCoins(0)
    .storeMaybeRef(forwardPayload)
    .endCell();
};

export function saleNftItemTransaction(params: SaleNftItemConfig) {
  const transactionAmount = "0.1";
  const masterAddress = Address.parse(params.saleAddress); // GetGems Address
  // const marketplaceFeeAddress = Address.parse(params.marketplaceFeeAddress); // GetGems Address for Fees
  // const destinationAddress = Address.parse(params.destinationAddress); // GetGems sale contracts deployer
  const walletAddress = Address.parseRaw(params.walletAddress);
  // const royaltyAddress = Address.parse(
  //   params.royaltyAddress || params.marketplaceFeeAddress
  // );
  const nftAddress = Address.parse(params.nftAddress);
  // const price = toNano(params.price);
  const { marketFee, royaltyFee, publicKey, signature, createdAt, queryId } =
    params;

  if (!publicKey) {
    throw Error("No publicKey");
  }

  if (!signature) {
    throw Error("No signature");
  }

  const nftTransferBody = getSendTransferBody(
    walletAddress,
    toNano(0.1),
    masterAddress
  );

  const transaction: SendTransactionRequest = {
    validUntil: Math.floor(Date.now() / 1000) + 3600,
    network,
    messages: [
      {
        address: nftAddress.toRawString(), //address of the NFT Item contract, that should be placed on market
        amount: toNano(transactionAmount).toString(), // amount that will require on gas fees, excess will be return
        payload: nftTransferBody.toBoc().toString("base64"), // payload with the transferNftBody message
      },
    ],
  };

  return {
    transaction,
  };
}
